import { useDate } from 'vuetify/framework'

export const getRemainingTime = (
  start_time: string,
  duration_in_milliseconds: number,
  is_utc: boolean = false
) => {
  const now = new Date()
  const endDate = new Date(is_utc ? dateToUTC(start_time) : start_time)
  endDate.setTime(endDate.getTime() + duration_in_milliseconds)
  const remainingSeconds = (endDate.getTime() - now.getTime()) / 1000
  if (remainingSeconds < 0) {
    return undefined
  }

  const hours = Math.floor(remainingSeconds / 3600)
  const minutes = Math.floor((remainingSeconds % 3600) / 60)
  const seconds = Math.floor(remainingSeconds % 60)

  if (hours === 0) {
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

export const dateToUTC = (value: string) => {
  return value.replace(' ', 'T') + '.000Z'
}

export const dateToLocal = (value: string, format: string) => {
  return useDate().format(dateToUTC(value), format)
}

export const differenceInDaysFromNow = (dateString: string) => {
  const utcDate = new Date(dateToUTC(dateString))
  const now = new Date()
  const timeDifferenceMs = Math.abs(now.getTime() - utcDate.getTime())
  const msInDay = 86400000
  return Math.floor(timeDifferenceMs / msInDay)

}

export const getChatGroupTitle = (dateStr: string, t: any, dateAdapter: any) => {
  const date = new Date(dateStr)
  const now = new Date()

  if (dateAdapter.isSameDay(date, now)) {
    return t('today')
  }

  const yesterday = new Date()
  yesterday.setDate(now.getDate() - 1)
  if (dateAdapter.isSameDay(date, yesterday)) {
    return t('yesterday')
  }

  if (dateAdapter.isSameMonth(date, now) && dateAdapter.isSameYear(date, now)) {
    return t('this_month')
  }

  if (!dateAdapter.isSameYear(date, now)) {
    return dateAdapter.format(date, 'monthAndYear')
  }

  return dateAdapter.format(date, 'month')
}

/**
 * Calculates the renewal date by adding a specified number of days to the current date
 * @param daysToAdd - Number of days to add to the current date
 * @returns Date object representing the renewal date
 */
export const calculateRenewalDate = (daysToAdd: number): Date => {
  const renewalDate = new Date()
  renewalDate.setDate(renewalDate.getDate() + daysToAdd)
  return renewalDate
}

/**
 * Formats a date to ISO format (YYYY-MM-DD)
 * @param date - Date object to format
 * @returns String in ISO format (YYYY-MM-DD)
 */
export const formatToISODate = (date: Date): string => {
  return date.toISOString().substring(0, 10)
}

/**
 * Calculates and formats the renewal date for a subscription
 * @param durationInDays - Duration of the subscription in days
 * @returns Formatted date string (YYYY-MM-DD) representing when the subscription will renew
 */
export const getSubscriptionRenewalDate = (durationInDays: number): string => {
  const renewalDate = calculateRenewalDate(durationInDays)
  return formatToISODate(renewalDate)
}
